// extracted by mini-css-extract-plugin
export default {"formInput":"LostPasswordPhoneForm_formInput__w-g9G","formPhoneWrapper":"LostPasswordPhoneForm_formPhoneWrapper__KBhO7"};